import { render, staticRenderFns } from "./VuesticIconFresh.vue?vue&type=template&id=3a9d4724"
import script from "./VuesticIconFresh.vue?vue&type=script&lang=js"
export * from "./VuesticIconFresh.vue?vue&type=script&lang=js"
import style0 from "./VuesticIconFresh.vue?vue&type=style&index=0&id=3a9d4724&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports